import angular from 'angular';
import 'angular-i18n/angular-locale_hu-hu';
import common from '../../common/common';
import hirekMorzsamenu from '../../applications/hirek/hirek-reszletes/hirek-morzsamenu';
import kapcsolat from '../../applications/kapcsolat/kapcsolat';
import rendezvenyekReszletes from '../../applications/rendezvenyek/rendezvenyek-reszletes/rendezvenyek-reszletes';

angular.module('AEVT-app', [
	common,
	hirekMorzsamenu,
	kapcsolat,
	rendezvenyekReszletes
]).constant('environment', window.__env).config(function ($locationProvider) {
	'ngInject';
	$locationProvider.hashPrefix('');
});
angular.bootstrap(document, ['AEVT-app']);



// WEBPACK FOOTER //
// ./source/layouts/AEVT/layout.js